<div class="table-card">
  <div *ngIf="isGestionComptesAnnonceur" class="card" id="card-add">
    <div class="card-add" (click)="createList()">
      <div class="cercle-dashed">
        <mat-icon class="add-icon">add</mat-icon>
      </div>
      <h2>{{ preferenceMessages.tab_1_label_2 | translate }}</h2>
    </div>
  </div>
  <div *ngFor="let item of sortList" class="card">
    <div class="etiquette-group">
      <h2 class="text-etiquette">{{item.titre}}</h2>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="update(item)">create</mat-icon>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="delete(item)">delete_outline</mat-icon>
      <app-partage-preference [id]="item.id" class="icon-etiquette"></app-partage-preference>
    </div>
    <div class="label-pos">
      <label>{{ item.compteur }} {{ preferenceMessages.tab_1_label_3 | translate }}</label>
    </div>
    <div class="contents">
      <div class="content mb-3" *ngFor="let val of item.diffuseurs">
        <span>{{textSupport(val)}}</span>
        <span class="ml-1">&#8226; <span class="gras">{{ preferenceMessages.tab_1_label_4 | translate }}</span><span *ngIf="!isDiffuseurJOUEBOAMP(val)"> {{getZoneGeo(val)}}</span></span>
        <span class="ml-1">&#8226; <span class="gras">{{ preferenceMessages.tab_1_label_5 | translate }}</span> {{val?.contact}}</span>
        <span class="ml-1">&#8226; <span class="gras">{{ preferenceMessages.tab_1_label_6 | translate }}</span> {{val?.email}}</span>
        <span class="ml-1">&#8226; <span class="gras">{{ preferenceMessages.tab_1_label_7 | translate }}</span> {{val?.telephone}}</span>
      </div>
    </div>
  </div>
</div>
